export const CErrorPasswordContext = {
    CHANGE_PASSWORD:'CHANGE_PASSWORD',
    RESET_PASSWORD: 'RESET_PASSWORD',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    SET_UP_PASSWORD: 'SET_UP_PASSWORD',
    SEND_CODE_VERIFY: 'SEND_CODE_VERIFY'
} as const;